import { getUcService, checkUcInit } from "./usercentrics.module";

const utm = (w, d, s, f, v) => {
  w[v] = w[v] || [];
  let e = d.getElementsByTagName(s)[0];
  let j = d.createElement(s);
  j.async = true;
  j.src = f;
  e.parentNode.insertBefore(j, e);
};

const fireEvents = (data, utm_source) => {
  let pt_pagetype = "seite";
  let pt_conversion_orderid = "";
  let pt_conversion_total = "";
  let pt_productname = "";
  let pt_productid = "";
  let dataScript = data.script;
  let uc_adition = getUcService(data.adition);
  let uc_xandr = getUcService(data.xandr);
  let uc_google_analytics = getUcService(data.ga);

  let sessPagetype = sessionStorage.getItem("pt_pagetype");
  if (sessPagetype) pt_pagetype = sessPagetype;

  let sessConvOrderid = sessionStorage.getItem("pt_conversion_orderid");
  if (sessConvOrderid) pt_conversion_orderid = sessConvOrderid;

  let sessConvTotal = sessionStorage.getItem("pt_conversion_total");
  if (sessConvTotal) pt_conversion_total = sessConvTotal;

  let sessProductName = sessionStorage.getItem("pt_productname");
  if (sessProductName) pt_productname = sessProductName;

  let sessProductId = sessionStorage.getItem("pt_productid");
  if (sessProductId) pt_productid = sessProductId;

  if (pt_pagetype == "seite") {
    let donation_form = document.querySelector(".custom-donation");
    if (!donation_form) {
      donation_form = document.querySelector("#donation-step-1");
    }

    if (donation_form) {
      pt_pagetype = "spendenformular";
      let dataLayer = (window.dataLayer = window.dataLayer || []);
      dataLayer.push({
        pt: { pagetype: "spendenformular" },
      });
    }
  }

  if (typeof window.utm268 === "undefined") {
    window.utm268 = {};
    window.utm268.data = {
      /* Settings General */
      advertiser_id: `adv_m_${data.id}`, // do not change
      pt_pagetype: pt_pagetype, // insert pagetype, possible values: 'home', 'product', 'category', 'conversion'
      /* Conversion */
      pt_conversion_orderid: pt_conversion_orderid, // insert your order ID or unique identifer (mandatory)
      pt_conversion_total: pt_conversion_total, // insert value of basket (optional)
      pt_conversion_quantity: "", // insert number of purchased products (optional)
      pt_conversion_success: "", // if Lasttouch / deduplication (Cookie-Weiche) insert 1, for hardcoded 0; Default 0
      /* Settings Categories */
      pt_category: "", // insert main category
      pt_subcategory1: "", // insert subcategory 1
      /* Settings Product */
      pt_productname: pt_productname, // insert product name
      pt_productid: pt_productid, // insert product id
      /* Settings Marketing_Channels */
      pt_channel: utm_source, // insert channel for visit or conversion
      /* Settings Custom Variables */
      pt_customvar1: uc_adition, // insert value for defined customvar1
      pt_customvar2: uc_google_analytics, // insert value for defined customvar2
      pt_customvar3: uc_xandr, // insert value for defined customvar3
      pt_customvar4: "", // insert value for defined customvar4
      pt_customvar5: "", // insert value for defined customvar5
      pt_customvar6: "", // insert value for defined customvar6
      pt_customvar7: "", // insert value for defined customvar7
      pt_customvar8: "", // insert value for defined customvar8
      pt_customvar9: "", // insert value for defined customvar9
      pt_customvar10: "", // insert value for defined customvar10
      /* Do not change */
      pt_loc: decodeURI(document.location.href), // do not change
      pt_ref: decodeURI(document.referrer), // do not change
      pt_protocol:
        "https:" == document.location.protocol ? "https://" : "http://", // do not change
      pt_cachebuster: new Date().getTime(), // do not change
      /* Do not remove this line */
    };

    utm(window, document, "script", dataScript, "utm268");
  }
};

export const init = () => {
  let rootElement = document.querySelector("#scriptUTT");
  let rootData = rootElement.dataset;
  let rootUC = rootData.piamedia;

  let url = window.location.href;
  let utm_source = null;

  // search all given keys
  let keyToFind = "utm_source";
  /// is there a utm source ?
  if (url.indexOf(keyToFind + "=") > -1) {
    utm_source = url
      .substr(url.indexOf(keyToFind + "=") + keyToFind.length + 1)
      .split("&")[0];
  } else {
    utm_source = sessionStorage.getItem("utm_source");
  }

  let attempts = 0;
  const whenComplete = async () => {
    if (++attempts > 30) return;
    if (await checkUcInit()) {
      if (getUcService(rootUC)) {
        fireEvents(rootData, utm_source);
      }
    } else {
      setTimeout(() => whenComplete(), 500);
    }
  };
  whenComplete();

  document.addEventListener("asuc-updated", () => {
    if (getUcService(rootUC)) {
      fireEvents(rootData, utm_source);
    }
  });
};
